import { Card } from '@kss/ui';

export default function About() {
  return (
    <div className="mx-auto max-w-4xl px-6 py-16">
      <h1 className="text-4xl font-extrabold tracking-tight">About KSS</h1>
      <p className="mt-4 text-[var(--color-text-secondary)]">
        KSS is a React monorepo template for teams shipping both marketing and admin experiences from a single codebase.
        Our goal is to remove boilerplate so engineers can focus on what their product actually does.
      </p>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        <Card title="Our mission">
          <p className="text-sm text-[var(--color-text-secondary)]">
            Build the defaults every team rebuilds: auth, theme, layout, data tables, currency. Share them across apps.
          </p>
        </Card>
        <Card title="Our approach">
          <p className="text-sm text-[var(--color-text-secondary)]">
            Pure React, zero magic. Each package is a thin, composable layer. No lock-in, no hidden globals.
          </p>
        </Card>
      </div>
    </div>
  );
}
